import React from 'react';
import { notification, Collapse } from 'antd';
import { inputName } from '../../config/constants/forms';

const { Panel } = Collapse;

const alertError = (response) => {

  const CollapsableMessage = (message) => {
    return (
      <Collapse ghost style={{ padding: 0 }}>
        <Panel header="Ver detalle" >
          {message}
        </Panel>
      </Collapse>
    );
  };

  const rejected = (response) => {
    if (response.errorFields) {
      const errorList = response.errorFields;
      const errorMessage = errorList?.slice(0, 14)
        .map((error, key) => (
          <p key={key}>Debe ingresar {
            inputName(error.name.length <= 1
              ? error.name[0]
              : `${error.name[0]}_${error.name[2]}`)
          }<br></br></p>
        ));
      notification.error({
        key: 'form_errors',
        message: `Faltan ${errorList?.length} campos por completar`,
        description: CollapsableMessage(errorMessage),
        className: 'custom-class',
        placement: 'topRight',
        duration: 15,
      });
    }
  };
  rejected(response);
};

export default alertError;